<vg-card-giftcard
    [img]="card?.design ? card?.design.url : (defaultCardDesign | cdn)"
>
    <div class="container-summary in-card">
        <div class="container-price">
            <div class="amount">
                {{ card?.amount | formatNumber }}
            </div>
            <div class="currency">MXN</div>
        </div>
        <div class="container-ellipsis">
            <div class="to">
                {{ 'vg_landing_dashboard_gifts_detail_to-label' | translate }}
                {{ card?.recipient }}
            </div>
        </div>
        <div class="from">
            {{ 'vg_landing_dashboard_gifts_detail_from-label' | translate }}
            {{ card?.gifter }}
        </div>
        <div class="code-title">
            {{
                'vg_landing_dashboard_gifts_detail_code-redeem-label'
                    | translate
            }}
        </div>
        <div class="container-code text-center">
            {{ card?.id | mask: 'AAAAA-AAAAA-AAAAA' }}
        </div>
        <div class="message font-family-lato">
            {{ card?.message }}
        </div>
    </div>
</vg-card-giftcard>
